import { isEmpty } from 'lodash';
import makeRequest from './client';

export const getFDALetters = (
    page: number,
    perPage: number,
    applicationQcStatus: string = '',
    taQcStatus: string = '',
    searchTerm = ''
) => {
    const baseURL = `/compliance/`;
    const queryParams = [`page=${page}`, `page_size=${perPage}`];
    if (!isEmpty(applicationQcStatus) && applicationQcStatus !== 'all') {
        queryParams.push(`application_qc_status=${applicationQcStatus}`);
    }
    if (!isEmpty(taQcStatus) && taQcStatus !== 'all') {
        queryParams.push(`ta_qc_status=${taQcStatus}`);
    }
    if (searchTerm) {
        queryParams.push(`search_term=${searchTerm}`);
    }
    const finalURL = `${baseURL}?${queryParams.join('&')}`;
    return makeRequest(finalURL, 'GET');
};

export const updateApplications = (letterId: string, applications: Array<any>) => {
    const baseURL = `/compliance/${letterId}/applications`;
    return makeRequest(baseURL, 'PUT', applications);
};

export const updateApplicationQcStatus = (letterId: string, payload: any) => {
    const baseURL = `/compliance/${letterId}/qc_status`;
    return makeRequest(baseURL, 'PUT', payload);
};

export const deleteApplication = (letterId: string, applicationId: string) => {
    const baseURL = `/compliance/${letterId}/application/${applicationId}`;
    return makeRequest(baseURL, 'DELETE');
};

export const getApplicationIndication = (letterId: string, applicationId: string) => {
    const baseURL = `/compliance/${letterId}/application/${applicationId}/indication`;
    return makeRequest(baseURL, 'GET');
};

export const updateApplicationIndication = (letterId: string, applicationId: string, payload: any) => {
    const baseURL = `/compliance/${letterId}/application/${applicationId}/indication/ta`;
    return makeRequest(baseURL, 'PUT', payload);
};
